/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SingleRecipePage_query$ref = any;
export type queries_RecipeQueryVariables = {|
  id: string
|};
export type queries_RecipeQueryResponse = {|
  +$fragmentRefs: SingleRecipePage_query$ref
|};
export type queries_RecipeQuery = {|
  variables: queries_RecipeQueryVariables,
  response: queries_RecipeQueryResponse,
|};
*/


/*
query queries_RecipeQuery(
  $id: ID!
) {
  ...SingleRecipePage_query_1Bmzm5
}

fragment AllergenRecipeModal_allAllergen on AllergenNodeConnection {
  edges {
    node {
      id
      name
    }
  }
}

fragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {
  edges {
    node {
      id
      name
      picture
    }
  }
}

fragment IngredientRecipeModal_allIngredients on IngredientNodeConnection {
  edges {
    node {
      id
      name
    }
  }
}

fragment IngredientRecipeModal_allUnitMeasure on UnitMeasureNodeConnection {
  edges {
    node {
      description
      code
      id
    }
  }
}

fragment IngredientsSummaryList_summaryIngredient on RecipeIngredientNodeConnection {
  edges {
    node {
      ingredient {
        name
        id
      }
      id
    }
  }
}

fragment RecipeDetails_recipe on RecipeNode {
  id
  published
  publicDate
  author {
    username
    id
  }
  allergen {
    edges {
      node {
        id
        name
        icon
      }
    }
  }
}

fragment RecipeInfo_recipe on RecipeNode {
  isTrend
  name
  description
  category {
    name
    id
  }
  labels {
    edges {
      node {
        id
        name
      }
    }
  }
  mediaFiles {
    edges {
      node {
        id
        mediaUrl
      }
    }
  }
  medRatings
  totalRatings
  difficulty
  serves
  time
}

fragment Recipe_recipe on RecipeNode {
  id
  name
  published
  ...RecipeInfo_recipe
  ...RecipeDetails_recipe
  favoritedBy {
    edges {
      node {
        username
        id
      }
    }
  }
  ...StepsList_recipe
  labels {
    edges {
      node {
        id
        name
      }
    }
  }
  recipeingredientSet {
    edges {
      node {
        id
        comments
        ingredient {
          id
          name
        }
        unityF {
          id
        }
        qty
        section {
          id
          name
        }
        fraction
      }
    }
  }
  recipeallergen {
    edges {
      node {
        id
        allergen {
          id
          name
          icon
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...SectionsList_recipe
  mediaFiles {
    edges {
      node {
        id
        mediaUrl
      }
    }
  }
}

fragment SectionsList_recipe on RecipeNode {
  section {
    edges {
      node {
        id
        name
        recipe {
          name
          id
        }
        recipeingredientSet {
          edges {
            node {
              id
              comments
              ingredient {
                name
                id
              }
              unityF {
                id
              }
              unity
              qty
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment SingleRecipePage_query_1Bmzm5 on Query {
  recipe(id: $id) {
    name
    ...Recipe_recipe
    id
  }
  summaryIngredient: allRecipeIngredients(recipe: $id, ingredient: "summary") {
    ...StepRecipeModal_summaryIngredient
    ...IngredientsSummaryList_summaryIngredient
  }
  allRecipeIngredients(recipe: $id, orderBy: "id") {
    edges {
      node {
        id
        comments
        ingredient {
          id
          name
        }
        unityF {
          id
        }
        qty
        section {
          id
          name
        }
        fraction
      }
    }
  }
  allCategories {
    ...DropdownCategories_allCategories
  }
  allWarnings {
    ...StepRecipeModal_allWarnings
  }
  configConstance {
    ...StepRecipeModal_configConstance
  }
  allIngredients {
    ...IngredientRecipeModal_allIngredients
  }
  allUnitMeasure {
    ...IngredientRecipeModal_allUnitMeasure
  }
  allAllergen {
    ...AllergenRecipeModal_allAllergen
  }
}

fragment StepRecipeModal_allWarnings on WarningNodeConnection {
  edges {
    node {
      id
      slugName
    }
  }
}

fragment StepRecipeModal_configConstance on ConfigConstance {
  speedLimit
  temperatureControlLimit
  temperatureDegreesMin
  temperatureDegreesMax
}

fragment StepRecipeModal_summaryIngredient on RecipeIngredientNodeConnection {
  edges {
    node {
      ingredient {
        id
        name
      }
      id
    }
  }
}

fragment StepsList_recipe on RecipeNode {
  steps {
    edges {
      node {
        id
        ordered
        description
        time
        speed
        temperatureDegrees
        temperatureControl
        turbo
        isRobot
        waitingInstructions
        media
        warning {
          edges {
            node {
              id
              slugName
            }
          }
        }
        ingredient {
          id
          name
        }
        weight
        unit
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v6 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "username",
    "storageKey": null
  },
  (v3/*: any*/)
],
v9 = [
  (v3/*: any*/),
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "icon",
    "storageKey": null
  }
],
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "WarningNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WarningNode",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slugName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "IngredientNode",
  "kind": "LinkedField",
  "name": "ingredient",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comments",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "UnitMeasureNode",
  "kind": "LinkedField",
  "name": "unityF",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qty",
  "storageKey": null
},
v18 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RecipeIngredientNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeIngredientNode",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v15/*: any*/),
          (v11/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeSectionNode",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fraction",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v19 = {
  "kind": "Variable",
  "name": "recipe",
  "variableName": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "queries_RecipeQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "SingleRecipePage_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "queries_RecipeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipeNode",
        "kind": "LinkedField",
        "name": "recipe",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "published",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTrend",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeCategoryNode",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LabelNodeConnection",
            "kind": "LinkedField",
            "name": "labels",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LabelNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeMediaNodeConnection",
            "kind": "LinkedField",
            "name": "mediaFiles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeMediaNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeMediaNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mediaUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "medRatings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalRatings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "difficulty",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serves",
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AllergenNodeConnection",
            "kind": "LinkedField",
            "name": "allergen",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AllergenNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AllergenNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNodeConnection",
            "kind": "LinkedField",
            "name": "favoritedBy",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeStepNodeConnection",
            "kind": "LinkedField",
            "name": "steps",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeStepNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeStepNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ordered",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "speed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "temperatureDegrees",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "temperatureControl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "turbo",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isRobot",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "waitingInstructions",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "media",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WarningNodeConnection",
                        "kind": "LinkedField",
                        "name": "warning",
                        "plural": false,
                        "selections": (v10/*: any*/),
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weight",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unit",
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": [],
            "handle": "connection",
            "key": "StepsList_steps",
            "kind": "LinkedHandle",
            "name": "steps"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeIngredientNodeConnection",
            "kind": "LinkedField",
            "name": "recipeingredientSet",
            "plural": false,
            "selections": (v18/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeAllergenNodeConnection",
            "kind": "LinkedField",
            "name": "recipeallergen",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeAllergenNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeAllergenNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AllergenNode",
                        "kind": "LinkedField",
                        "name": "allergen",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": [],
            "handle": "connection",
            "key": "allergens_recipeallergen",
            "kind": "LinkedHandle",
            "name": "recipeallergen"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeSectionNodeConnection",
            "kind": "LinkedField",
            "name": "section",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeSectionNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecipeSectionNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecipeNode",
                        "kind": "LinkedField",
                        "name": "recipe",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecipeIngredientNodeConnection",
                        "kind": "LinkedField",
                        "name": "recipeingredientSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RecipeIngredientNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RecipeIngredientNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "IngredientNode",
                                    "kind": "LinkedField",
                                    "name": "ingredient",
                                    "plural": false,
                                    "selections": (v5/*: any*/),
                                    "storageKey": null
                                  },
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "unity",
                                    "storageKey": null
                                  },
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": [],
            "handle": "connection",
            "key": "SectionsList_section",
            "kind": "LinkedHandle",
            "name": "section"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "summaryIngredient",
        "args": [
          {
            "kind": "Literal",
            "name": "ingredient",
            "value": "summary"
          },
          (v19/*: any*/)
        ],
        "concreteType": "RecipeIngredientNodeConnection",
        "kind": "LinkedField",
        "name": "allRecipeIngredients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeIngredientNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeIngredientNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "orderBy",
            "value": "id"
          },
          (v19/*: any*/)
        ],
        "concreteType": "RecipeIngredientNodeConnection",
        "kind": "LinkedField",
        "name": "allRecipeIngredients",
        "plural": false,
        "selections": (v18/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeCategoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "picture",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "WarningNodeConnection",
        "kind": "LinkedField",
        "name": "allWarnings",
        "plural": false,
        "selections": (v10/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigConstance",
        "kind": "LinkedField",
        "name": "configConstance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "speedLimit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "temperatureControlLimit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "temperatureDegreesMin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "temperatureDegreesMax",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IngredientNodeConnection",
        "kind": "LinkedField",
        "name": "allIngredients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IngredientNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IngredientNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UnitMeasureNodeConnection",
        "kind": "LinkedField",
        "name": "allUnitMeasure",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitMeasureNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitMeasureNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AllergenNodeConnection",
        "kind": "LinkedField",
        "name": "allAllergen",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AllergenNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AllergenNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "queries_RecipeQuery",
    "operationKind": "query",
    "text": "query queries_RecipeQuery(\n  $id: ID!\n) {\n  ...SingleRecipePage_query_1Bmzm5\n}\n\nfragment AllergenRecipeModal_allAllergen on AllergenNodeConnection {\n  edges {\n    node {\n      id\n      name\n    }\n  }\n}\n\nfragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {\n  edges {\n    node {\n      id\n      name\n      picture\n    }\n  }\n}\n\nfragment IngredientRecipeModal_allIngredients on IngredientNodeConnection {\n  edges {\n    node {\n      id\n      name\n    }\n  }\n}\n\nfragment IngredientRecipeModal_allUnitMeasure on UnitMeasureNodeConnection {\n  edges {\n    node {\n      description\n      code\n      id\n    }\n  }\n}\n\nfragment IngredientsSummaryList_summaryIngredient on RecipeIngredientNodeConnection {\n  edges {\n    node {\n      ingredient {\n        name\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment RecipeDetails_recipe on RecipeNode {\n  id\n  published\n  publicDate\n  author {\n    username\n    id\n  }\n  allergen {\n    edges {\n      node {\n        id\n        name\n        icon\n      }\n    }\n  }\n}\n\nfragment RecipeInfo_recipe on RecipeNode {\n  isTrend\n  name\n  description\n  category {\n    name\n    id\n  }\n  labels {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  mediaFiles {\n    edges {\n      node {\n        id\n        mediaUrl\n      }\n    }\n  }\n  medRatings\n  totalRatings\n  difficulty\n  serves\n  time\n}\n\nfragment Recipe_recipe on RecipeNode {\n  id\n  name\n  published\n  ...RecipeInfo_recipe\n  ...RecipeDetails_recipe\n  favoritedBy {\n    edges {\n      node {\n        username\n        id\n      }\n    }\n  }\n  ...StepsList_recipe\n  labels {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  recipeingredientSet {\n    edges {\n      node {\n        id\n        comments\n        ingredient {\n          id\n          name\n        }\n        unityF {\n          id\n        }\n        qty\n        section {\n          id\n          name\n        }\n        fraction\n      }\n    }\n  }\n  recipeallergen {\n    edges {\n      node {\n        id\n        allergen {\n          id\n          name\n          icon\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...SectionsList_recipe\n  mediaFiles {\n    edges {\n      node {\n        id\n        mediaUrl\n      }\n    }\n  }\n}\n\nfragment SectionsList_recipe on RecipeNode {\n  section {\n    edges {\n      node {\n        id\n        name\n        recipe {\n          name\n          id\n        }\n        recipeingredientSet {\n          edges {\n            node {\n              id\n              comments\n              ingredient {\n                name\n                id\n              }\n              unityF {\n                id\n              }\n              unity\n              qty\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SingleRecipePage_query_1Bmzm5 on Query {\n  recipe(id: $id) {\n    name\n    ...Recipe_recipe\n    id\n  }\n  summaryIngredient: allRecipeIngredients(recipe: $id, ingredient: \"summary\") {\n    ...StepRecipeModal_summaryIngredient\n    ...IngredientsSummaryList_summaryIngredient\n  }\n  allRecipeIngredients(recipe: $id, orderBy: \"id\") {\n    edges {\n      node {\n        id\n        comments\n        ingredient {\n          id\n          name\n        }\n        unityF {\n          id\n        }\n        qty\n        section {\n          id\n          name\n        }\n        fraction\n      }\n    }\n  }\n  allCategories {\n    ...DropdownCategories_allCategories\n  }\n  allWarnings {\n    ...StepRecipeModal_allWarnings\n  }\n  configConstance {\n    ...StepRecipeModal_configConstance\n  }\n  allIngredients {\n    ...IngredientRecipeModal_allIngredients\n  }\n  allUnitMeasure {\n    ...IngredientRecipeModal_allUnitMeasure\n  }\n  allAllergen {\n    ...AllergenRecipeModal_allAllergen\n  }\n}\n\nfragment StepRecipeModal_allWarnings on WarningNodeConnection {\n  edges {\n    node {\n      id\n      slugName\n    }\n  }\n}\n\nfragment StepRecipeModal_configConstance on ConfigConstance {\n  speedLimit\n  temperatureControlLimit\n  temperatureDegreesMin\n  temperatureDegreesMax\n}\n\nfragment StepRecipeModal_summaryIngredient on RecipeIngredientNodeConnection {\n  edges {\n    node {\n      ingredient {\n        id\n        name\n      }\n      id\n    }\n  }\n}\n\nfragment StepsList_recipe on RecipeNode {\n  steps {\n    edges {\n      node {\n        id\n        ordered\n        description\n        time\n        speed\n        temperatureDegrees\n        temperatureControl\n        turbo\n        isRobot\n        waitingInstructions\n        media\n        warning {\n          edges {\n            node {\n              id\n              slugName\n            }\n          }\n        }\n        ingredient {\n          id\n          name\n        }\n        weight\n        unit\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '096211bffae50e22e6b6910eeda34b7e';

module.exports = node;
